const SmallTwoArrowConnection = () => {
  return (
    <div className="flex justify-center gap-10">
      {/* Left Connection */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="229"
        height="156"
        viewBox="0 0 229 156"
        fill="none"
      >
        <path
          d="M226.5 2.5V32.6087C226.5 45.8635 215.755 56.6087 202.5 56.6087H26.5C13.2452 56.6087 2.5 67.3538 2.5 80.6087V153.5"
          stroke="url(#leftGradient)"
          strokeWidth="5"
          strokeLinecap="square"
        />

        <defs>
          <linearGradient
            id="leftGradient"
            x1="2.5"
            y1="153.5"
            x2="118.366"
            y2="-57.0159"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#DFDFDF">
              <animate
                attributeName="offset"
                values="1;-1"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>

            <stop offset="50%" stopColor="#2D65F2">
              <animate
                attributeName="offset"
                values="2;0"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>

            <stop offset="100%" stopColor="#FFFFFF">
              <animate
                attributeName="offset"
                values="3;1"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
        </defs>
      </svg>

      {/* Right Connection */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="229"
        height="156"
        viewBox="0 0 229 156"
        fill="none"
      >
        <path
          d="M2.49999 2.5V32.6087C2.49999 45.8635 13.2452 56.6087 26.5 56.6087H202.5C215.755 56.6087 226.5 67.3538 226.5 80.6087V153.5"
          stroke="url(#rightGradient)"
          strokeWidth="5"
          strokeLinecap="square"
        />

        <defs>
          <linearGradient
            id="rightGradient"
            x1="226.5"
            y1="153.5"
            x2="110.698"
            y2="-57.0178"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#DFDFDF">
              <animate
                attributeName="offset"
                values="1;-1"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>

            <stop offset="50%" stopColor="#2D65F2">
              <animate
                attributeName="offset"
                values="2;0"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>

            <stop offset="100%" stopColor="#FFFFFF">
              <animate
                attributeName="offset"
                values="3;1"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default SmallTwoArrowConnection;
